import loadable from '@loadable/component';

const ManageApps = loadable(() =>
  import('./manage-apps').then((module) => module.ManageApps),
);

export { ManageApps };
